import type { KeyLevelSubTypes } from '@einhaus/project314-types';
export { OPTIONS_DATA_START_DATETIME } from '@einhaus/project314-shared';

export const ADMIN_USER_TYPES = [9];
export const USER_TYPES = [1, 9];

export const KEY_LEVEL_TYPES = {
    PIVOT_POINT: 1,
    PIVOT_POINT_FIBNACCI: 2,
    PIVOT_POINT_DEMARK: 3,
    OPENING_MOVE_FIBONACCI: 4,
    AFTERNOON_FIBONACCI: 5,
    AFTERHOURS_FIBONNACI: 6,
    PREVIOUS_DAY_FIBONACCI: 7
};

export const KEY_LEVEL_SUBTYPES: KeyLevelSubTypes = {
    pivotPoint: 1,
    s1: 2,
    s2: 3,
    s3: 4,
    r1: 5,
    r2: 6,
    r3: 7,
    '0.236': 8,
    '0.382': 9,
    '0.5': 10,
    '0.618': 11,
    '0.786': 12,
    '1': 13,
    '1.272': 14,
    '1.414': 15,
    '1.618': 16,
    '2': 17,
    '2.618': 18,
    '-0.236': 19,
    '-0.382': 20,
    '-0.5': 21,
    '-0.618': 22,
    '-0.786': 23,
    '-1': 24,
    '-1.272': 25,
    '-1.414': 26,
    '-1.618': 27,
    '-2': 28,
    '-2.618': 29,
    '0': 30
};

export const OPTION_TRADING_FEE = 0.65;
export const DEFAULT_STARTING_BALANCE = 100000;
export const DEFAULT_TRADE_SIZE = 10000;
export const AUTO_SELECT_ID = 999999;

export const ADMIN_USER_TYPE = 9;

export const TRANSIENT_ERROR_RETRY_COUNT = 3;

export const DEFAULT_REQUISITIES_STALE_TIME = 120000;
